angular.module 'zc.commonApi'

.factory "MongoHistory", ($q, FacadeV2) ->


  class MongoHistory

    @find: (query, options = {}) ->
      $q (resolve, reject) ->
        query ||= {}

        unless query.apikey
          return reject "No apikey"

        FacadeV2.request "/apikeys/#{query.apikey}/histories",
          params:
            match: query
            sort: options.sort
            limit: options.limit || 1000
            fields: options.fields
          cache: false
        .then (res) ->
          if res.status != 200 || res.data.error
            reject res.data.error
          else
            resolve res.data

    @aggregate: (paths, query) ->
      params = {}
      params.match = query.match
      params.pipeline = query.pipeline
      params.limit = query.limit || 1000

      FacadeV2.request "/apikeys/#{paths.apikey}/histories/aggregate", {
        params: params
      }
      .then (res) ->
        res.data

  MongoHistory



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/mongo_history.service.coffee